import { Box } from 'components/elements'
import { ShimmerCss } from '.'

export const ListShimmer = () => {
  return (
    <Box css={{ p: '$space$12 $space$16' }}>
      <Box css={{ ...ShimmerCss, ...ListItemCss }}></Box>
    </Box>
  )
}

const ListItemCss = {
  width: 150,
  height: 24,
}
